import { useO365ShellShim, useStatus as useSuiteHeaderLoadStatus } from '@ms/yammer-hooks/dist/suiteHeader';

type UseShouldRenderVivaAppBar = () => boolean;
export const useIsSuiteHeaderAvailable: UseShouldRenderVivaAppBar = () => {
  const isSuiteHeaderLoaded = useSuiteHeaderLoadStatus() === 'fulfilled';
  const isOneShellShimAvailable = !!useO365ShellShim();

  return isSuiteHeaderLoaded && isOneShellShimAvailable;
};
